// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"b06a7778","761":"bf9ac3e9","917":"c1666b20"}[chunkId] + ".chunk.css";
};